import { Change } from './change';

export class Changes {
  constructor(public rootId: string, public changes: Change[]) {}
}
